'use strict';

require('./appIncludes.js');
require('./bootstrap.js');
